import { createRouter, createWebHistory } from "vue-router";

// --- VISTAS PRINCIPALES ---
import InicioView from "@/views/InicioView.vue";
import ServiciosView from "@/views/ServiciosView.vue";
import CalendarioView from "@/views/CalendarioView.vue";
import ProyectosView from "@/views/ProyectosView.vue";
import BlogView from "@/views/BlogView.vue";
import ContactoView from "@/views/ContactoView.vue";
import OtrosView from "@/views/OtrosView.vue";

// --- MÓDULO DE RESERVAS ---
import ReservasView from "@/views/reservas/ReservasView.vue";
import EditarReservaView from "@/views/reservas/EditarReservaView.vue";
import CancelarReservaView from "@/views/reservas/CancelarReservaView.vue";
import ConfirmarEsperaView from "@/views/reservas/ConfirmarEsperaView.vue";

// --- LEGAL ---
import PoliticadecancelacionesView from "@/views/legal/PoliticadecancelacionesView.vue";
import AvisolegalView from "@/views/legal/AvisolegalView.vue";
import PoliticadeprivacidadView from "@/views/legal/PoliticadeprivacidadView.vue";

// --- VISTAS DE PROYECTOS ---
import DetalleFlyschView from "@/views/proyectos/DetalleFlyschView.vue";
import DetalleZallaNaturaView from "@/views/proyectos/DetalleZallaNaturaView.vue";
import DetalleAsteBerdeaView from "@/views/proyectos/DetalleAsteBerdeaView.vue";
import DetalleSopelaKostaFestView from "@/views/proyectos/DetalleSopelaKostaFestView.vue";

// --- VISTAS DEL BLOG ---
import NummulitesView from "@/views/blog/NummulitesView.vue";
import BombasSemillasView from "@/views/blog/BombasSemillasView.vue";
import MicelioView from "@/views/blog/MicelioView.vue";
import FlyschBizkaiaView from "@/views/blog/FlyschBizkaiaView.vue";
import PatrimonioEuropeoView from "@/views/blog/PatrimonioEuropeoView.vue";
import FreeToursView from "@/views/blog/FreeToursView.vue";
import ValerianaRojaView from "@/views/blog/ValerianaRojaView.vue";
import EstuariosView from "@/views/blog/EstuariosView.vue";
import MariquitasView from "@/views/blog/MariquitasView.vue";
import BiodiversidadView from "@/views/blog/BiodiversidadView.vue";
import SapitoView from "@/views/blog/SapitoView.vue";
import CarpobrotusView from "@/views/blog/CarpobrotusView.vue";
import FloraAutoctonaView from "@/views/blog/FloraAutoctonaView.vue";
import FosilesView from "@/views/blog/FosilesView.vue";
import DiaTierraView from "@/views/blog/DiaTierraView.vue";
import EstramonioView from "@/views/blog/EstramonioView.vue";

// --- COMPONENTES DE SERVICIOS (Detalles) ---
import DetalleRutas from "@/components/servicios/DetalleRutas.vue";
import DetalleActividades from "@/components/servicios/DetalleActividades.vue";
import DetalleSensibilizacion from "@/components/servicios/DetalleSensibilizacion.vue";
import DetalleDigitalySostenible from "@/components/servicios/DetalleDigitalySostenible.vue";
import DetalleFormacion from "@/components/servicios/DetalleFormacion.vue";
import DetalleDescargas from "@/components/servicios/DetalleDescargas.vue";
import FitxasEtnobotanicasEnkarterri from "@/components/contenido-creado/FitxasEtnobotanicasEnkarterri.vue";

// --- GESTIÓN DE ACTIVIDADES ---
import AdminView from '@/views/AdminView.vue';

// --- RUTAS ---
const routes = [
  // Inicio y Páginas Generales
  { path: "/", name: "inicio", component: InicioView },
  { path: "/servicios", name: "servicios", component: ServiciosView },
  { path: "/calendario", name: "calendario", component: CalendarioView },
  { path: "/proyectos", name: "proyectos", component: ProyectosView },
  { path: "/experiencia", redirect: "/proyectos" },
  { path: "/contacto", name: "contacto", component: ContactoView },
  { path: "/otros", name: "otros", component: OtrosView },

  // Módulo de Reservas y Lista de Espera
  { path: "/reservas", name: "reservas", component: ReservasView },
  { path: "/reservas/:id", name: "reservaActividad", component: ReservasView },
  { path: "/reservas/editar", name: "editarReserva", component: EditarReservaView, meta: { noindex: true } },
  { path: "/reservas/cancelar", name: "cancelarReserva", component: CancelarReservaView, meta: { noindex: true } },
  { path: "/reservas/confirmar-espera", name: "confirmarEspera", component: ConfirmarEsperaView, meta: { noindex: true } },

  // Redirecciones SEO de Servicios
  { path: "/detalle-rutas", redirect: "/servicios/rutas" },
  { path: "/detalle-actividades", redirect: "/servicios/actividades" },
  { path: "/detalle-sensibilizacion", redirect: "/servicios/sensibilizacion" },
  { path: "/detalle-digital", redirect: "/servicios/digital-sostenible" },
  { path: "/detalle-formacion", redirect: "/servicios/formacion" },
  { path: "/detalle-descargas", redirect: "/servicios/descargas" },
  { path: "/detalle-semana-verde", redirect: "/detalle-aste-berdea" },
  { path: "/detalle-dia-de-arbol", redirect: "/servicios/sensibilizacion" },

  // Rutas Jerárquicas de Servicios
  { path: "/servicios/rutas", name: "DetalleRutas", component: DetalleRutas },
  { path: "/servicios/actividades", name: "DetalleActividades", component: DetalleActividades },
  { path: "/servicios/sensibilizacion", name: "DetalleSensibilizacion", component: DetalleSensibilizacion },
  { path: "/servicios/digital-sostenible", name: "DetalleDigitalySostenible", component: DetalleDigitalySostenible },
  { path: "/servicios/formacion", name: "DetalleFormacion", component: DetalleFormacion },
  { path: "/servicios/descargas", name: "DetalleDescargas", component: DetalleDescargas },
  { path: "/fitxas-etnobotanicas-enkarterri", name: "fitxas-etnobotanicas-enkarterri", component: FitxasEtnobotanicasEnkarterri },

  // Proyectos
  { path: "/detalle-flysch", name: "detalle-flysch", component: DetalleFlyschView },
  { path: "/detalle-zalla-natura", name: "detalle-zalla-natura", component: DetalleZallaNaturaView },
  { path: "/detalle-aste-berdea", name: "detalle-aste-berdea", component: DetalleAsteBerdeaView },
  { path: "/detalle-sopela-kosta-fest", name: "detalle-sopela-kosta-fest", component: DetalleSopelaKostaFestView },

  // Blog
  { path: "/blog", name: "blog", component: BlogView },
  { path: "/blog/bombas-de-semillas", name: "bombas-de-semillas", component: BombasSemillasView },
  { path: "/blog/micelio", name: "micelio", component: MicelioView },
  { path: "/blog/nummulites-flysch", name: "nummulites-flysch", component: NummulitesView },
  { path: "/blog/flysch-bizkaia", name: "flysch-bizkaia", component: FlyschBizkaiaView },
  { path: "/blog/patrimonio-europeo", name: "patrimonio-europeo", component: PatrimonioEuropeoView },
  { path: "/blog/free-tours", name: "free-tours", component: FreeToursView },
  { path: "/blog/valeriana-roja", name: "valeriana-roja", component: ValerianaRojaView },
  { path: "/blog/estuarios", name: "estuarios", component: EstuariosView },
  { path: "/blog/mariquitas", name: "mariquitas", component: MariquitasView },
  { path: "/blog/biodiversidad", name: "biodiversidad", component: BiodiversidadView },
  { path: "/blog/sapito-corredor", name: "sapito-corredor", component: SapitoView },
  { path: "/blog/carpobrotus", name: "carpobrotus", component: CarpobrotusView },
  { path: "/blog/estramonio", name: "estramonio", component: EstramonioView },
  { path: "/blog/flora-autoctona", name: "flora-autoctona", component: FloraAutoctonaView },
  { path: "/blog/fosiles", name: "fosiles", component: FosilesView },
  { path: "/blog/dia-tierra", name: "dia-tierra", component: DiaTierraView },

  // Legal
  { path: "/politicadecancelaciones", name: "cancelaciones", component: PoliticadecancelacionesView },
  { path: "/avisolegal", name: "aviso", component: AvisolegalView },
  { path: "/politicadeprivacidad", name: "privacidad", component: PoliticadeprivacidadView },

  // Gestión de Actividades (Admin)
  { path: "/admingestion", name: "admin", component: AdminView, meta: { title: 'Gestión Geobizi', noindex: true, manifest: '/admin.webmanifest' } },

  // Ruta 404 (Wildcard)
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFoundView.vue"),
    meta: { title: 'Página no encontrada | Geobizi', noindex: true },
    beforeEnter: (to, from, next) => {
      if (to.fullPath.includes("/geotienda/") || to.fullPath.includes("/investigacion/")) {
        next({ path: "/servicios", replace: true });
      } else {
        next();
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.afterEach((to) => {
  // 1. Google Analytics 4
  if (typeof window.gtag === "function") {
    window.gtag("config", "G-LVMVX3Z14P", {
      page_path: to.path,
    });
  }

  // 2. Título dinámico
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 3. Protección anti-indexación para admin
  let robotsTag = document.querySelector('meta[name="robots"]');
  if (to.meta.noindex) {
    if (!robotsTag) {
      robotsTag = document.createElement('meta');
      robotsTag.setAttribute('name', 'robots');
      document.head.appendChild(robotsTag);
    }
    robotsTag.setAttribute('content', 'noindex, nofollow, noarchive');
  } else if (robotsTag) {
    robotsTag.setAttribute('content', 'index, follow');
  }

  // 4. Manifiesto de instalación: el panel se instala como una app propia
  const manifestTag = document.querySelector('link[rel="manifest"]');
  if (manifestTag) {
    manifestTag.setAttribute('href', to.meta.manifest || '/manifest.webmanifest');
  }
});

export default router;